exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-07c9254a] .el-table__row{height:56px}\n", ""]);

// exports
